module.exports = __webpack_public_path__ + "img/gsjjbg.b3dd206a.png";